// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Photos__row":"tg_a bib_a bib_r bib_j","Photos__img":"tg_b bib_b"};